import { z } from 'zod';

export const questionVendorMapScheme = z.object({
  form_question_id: z.number().int().positive(),
  vendor_id: z.number().int().positive(),
  external_question_id: z.string().min(1),
  external_options_id: z.array(
    z.object({
      form_option_id: z.number().int().positive(),
      external_option_id: z.string().min(1),
    })
  ),
});
export type QuestionVendorInput = z.infer<typeof questionVendorMapScheme>;
